import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
// import SuccessIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import { Typography } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';

// const COLOR_INFO = '#006AB3';
// const COLOR_SUCCESS = '#009767';

const useStyles = makeStyles((theme: Theme) => ({
    content: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 5,
        padding: 6,
        display: 'flex',
        alignItems: 'center',
    },

    icon: {
        width: 24,
        height: 24,
        marginRight: 6,
    },

    // *** INFO
    infoContent: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light
    },

    infoColor: {
        color: '#FFF',
        fontSize: 14,
    },

    // *** INFO-LoW
    infoLowContent: {
        borderColor: theme.palette.grey.A200,
        backgroundColor: '#9bb2bd'
    },

    infoLowColor: {
        color: '#FFF',
        fontSize: 14
    },
    // *** ERROR
    errorIcon: {
        color: 'white'
    },

    errorContent: {
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.error.light
    },
    errorColor: {
        //color: theme.palette.error.light,
        fontSize: 14
    }

    // *** SUCCESS
    /*
    successContent: {
        borderColor: COLOR_SUCCESS,
    },

    successColor: {
        color: COLOR_SUCCESS
    }
    */
}));


function renderInfo(styleClass: ClassNameMap, children: React.ReactNode) {
    return (
        <div style={{ display: 'flex' }} className={`${styleClass.content} ${styleClass.infoContent}`}>
            <InfoIcon className={`${styleClass.icon} ${styleClass.infoColor}`} />
            <Typography variant='body2' color='textSecondary' component='div' className={styleClass.infoColor}>{children}</Typography>
        </div>);
}

function renderInfoLow(styleClass: ClassNameMap, children: React.ReactNode) {
    return (
        <div style={{ display: 'flex' }} className={`${styleClass.content} ${styleClass.infoLowContent}`}>
            <InfoIcon className={`${styleClass.icon} ${styleClass.infoLowColor}`} />
            <Typography variant='body2' color='textSecondary' component='div' className={styleClass.infoLowColor}>{children}</Typography>
        </div>);
}

function renderError(styleClass: ClassNameMap, children: React.ReactNode) {
    return (
        <div style={{ display: 'flex' }} className={`${styleClass.content} ${styleClass.errorContent}`}>
            <ErrorIcon className={`${styleClass.icon} ${styleClass.errorIcon}`} />
            <Typography variant='body2' color='textSecondary' component='div' className={styleClass.errorColor}>{children}</Typography>
        </div>);
}
/*
function renderSuccess(styleClass: ClassNameMap, children: React.ReactNode) {
    return (
        <div className={`${styleClass.content} ${styleClass.successContent}`}>
            <SuccessIcon className={`${styleClass.icon} ${styleClass.successColor}`} />
            <Typography variant='body2' className={styleClass.successColor}>{children}</Typography>
        </div>);
}
*/
type Param = {
    severity: 'info' | 'info-low' | 'error'; // | 'success';
};


const AlertDisplay: React.FC<Param> = ({ severity, children }) => {
    const classes = useStyles();
    return (
        (severity === 'info') ? renderInfo(classes, children) :
            (severity === 'info-low') ? renderInfoLow(classes, children) :
                (severity === 'error') ? renderError(classes, children) : null);
    //(severity === 'success') ? renderSuccess(classes, children) : null);
}


export default AlertDisplay;

